export const HOUSES = 'houses'
export const BOOKS = 'books'
export const BOOK = 'book'
export const CHARACTERS = 'characters'

export const API_BASE = 'https://www.anapioficeandfire.com/api'
export const FIREBASE_DB_URL = 'https://react-got-db-app-6864e.firebaseio.com'